import { posthog } from 'posthog-js';
import { getParentDomain } from '../components/Configurator/utils';

export const LEISURE_CREATIONS_DOMAIN = 'www.leisurecreationsfurniture.com';

export const WESTMINSTER_DOMAIN = 'www.westminsterteak.com';

export const TEST_DOMAIN = 'www.w3schools.com'; // TO DO: This is only for testing purpose

export const KEY_MAPPINGS = {
  [LEISURE_CREATIONS_DOMAIN]: 'phc_axwSoUY2LbGzDXV82gdcpuIxkg1ijHFwXBgngXEhMwm',
  [WESTMINSTER_DOMAIN]: 'phc_AfEdorSE2TjHgtac354rWLhItjMW27Dmipw6tdQNNUz',
  // [TEST_DOMAIN]: 'phc_AfEdorSE2TjHgtac354rWLhItjMW27Dmipw6tdQNNUz', // TO DO: This is only for testing purpose
};

export const initPostHog = () => {
  const parentDomain = getParentDomain();
  if (!parentDomain) return;
  const url = new URL(parentDomain);
  const hostName = url.hostname;
  const key = KEY_MAPPINGS?.[hostName];
  if (!key) return;
  posthog.init(key, {
    api_host: process.env.REACT_APP_POST_HOG_HOST,
    defaults: '2025-05-24',
  });
};

export const trackPostHogEvent = (eventName, params = {}) => {
  const finalParams = {
    ...params,
    time_stamp: Date.now(),
    page_source: window.location.pathname,
  };
  // Posthog
  posthog.capture(eventName, finalParams);
};
